
/*
 *
 * Date: 2025
 * Description: Main user form
 * Author: Philippe Leroux @SKITSC
 *
 */
//Modules
import { Box , TextField , Typography , Button, Paper , MenuItem , InputAdornment , IconButton , Grid } from "@mui/material"
import { ChangeEvent , useState } from "react"

//Interfaces
import { i_user_form , i_user } from "../../interfaces/user.interface"
import { i_select } from "../../interfaces/items.interface";

//Icons
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

//Constants
import { country, provinces } from "../../utils/constant";

const UserForm = ( props : i_user_form ) => {
    const [ visibility, setVisibility ] = useState<boolean>(false)
    const handleField = ( event : ChangeEvent<HTMLInputElement> ) => {
        const { name, value } = event.target
        if(name.charAt(0) === 'A'){
            var cleanName : string = name.slice(1)
            props.setForm({...props.form, address : { ...props.form.address, [cleanName] : value}})
        }else{
            if(name === 'type'){
                props.setForm({...props.form, type : value === 'admin' ? 'admin' : 'user'})
            }else{
                props.setForm({...props.form, [name] : value})
            }
        }
    }
    const F : i_user = props.form
    const E : i_user = props.errors
    const btnSubmit = { width: '100%', maxWidth : '300px' , marginLeft : 'auto' , marginRight : 'auto' , marginTop: '1vh'}
    const newBox = { display : 'flex' , alignItems : 'center' , marginBottom : '18px'}
    const boxingRow = { display : 'flex' , alignSelf : 'center' , alignItems : 'center' , width : '100%' , marginBottom : '1vh'}
    const labelTitle = { width : '40%' , textAlign : 'center' , fontSize : 16 , fontWeight : 'bolder'}
    const inputShape = { width : '60%' , maxWidth :" 400px"}
    return (
        <Paper elevation={3} sx={{ padding : 5 , maxWidth : '1400px' , marginLeft : 'auto' , marginRight : 'auto'}}>
            <Grid container>
                <Grid size={6} sx={newBox}>
                    <Typography sx={labelTitle}>Username *:</Typography>
                    <TextField sx={inputShape} autoComplete="off" name={'username'} value={F.username} onChange={handleField} helperText={E.username} error={E.username !== '' ? true : false }/>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Typography sx={labelTitle}>Email *:</Typography>
                    <TextField sx={inputShape} autoComplete="new-email" name={'email'} value={F.email} onChange={handleField} helperText={E.email} error={E.email !== '' ? true : false }/>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Typography sx={labelTitle}>Password *:</Typography>
                    <TextField type={ visibility ? 'text' : 'password'} autoComplete="new-password" sx={inputShape} name={'password'} value={F.password} onChange={handleField} helperText={E.password} error={E.password !== '' ? true : false }
                      slotProps={{
                        input: {
                            endAdornment: 
                            <InputAdornment position="end">
                                <IconButton aria-label={ visibility ? 'hide the password' : 'display the password' } onClick={() => setVisibility( visibility ? false : true  )} edge="end" >
                                    {visibility ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                      }}}/>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Box sx={labelTitle}>Phone *:</Box>
                    <TextField sx={inputShape} value={F.phone} onChange={handleField} name={'phone'} helperText={E.phone} error={E.phone !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Box sx={labelTitle}>Credit Limit *:</Box>
                    <TextField sx={inputShape}type="number" name={'creditLimit'} value={F.creditLimit} onChange={handleField}></TextField>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Typography sx={labelTitle}>User type*</Typography>
                    <TextField sx={inputShape} select value={F.type.toString()} onChange={handleField} name={'type'}>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="user">User</MenuItem>
                    </TextField>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Box sx={labelTitle}>Business name:</Box>
                    <TextField sx={inputShape} value={F.businessName} onChange={handleField} name={'businessName'} helperText={E.businessName} error={E.businessName !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={6} sx={newBox}>
                    <Box sx={labelTitle}>Account number :</Box>
                    <TextField sx={inputShape} value={F.accountNumber} onChange={handleField} name={'accountNumber'} helperText={E.accountNumber} error={E.accountNumber !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={12}>
                    <Typography sx={{ textAlign : 'center' , width : '100%' , marginTop : '2vh' , fontSize : 20 , fontWeight : 800}}>Contact informations</Typography>                    
                    <Typography sx={{ color : 'red' , fontWeight : 600 , fontSize : 18 , textAlign : 'center' , marginTop : '2vh', marginBottom : '2vh'}}>J'attend tes informations de clients./.</Typography>
                </Grid>             
                <Grid size={4} sx={newBox}>
                    <Box sx={labelTitle}>Unit num :</Box>
                    <TextField sx={inputShape} value={F.address.unitNumber} onChange={handleField} name={'AunitNumber'} helperText={E.address.unitNumber} error={E.address.unitNumber !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={4} sx={newBox}>
                    <Box sx={labelTitle}>Door num *:</Box>
                    <TextField sx={inputShape} value={F.address.doorNumber} onChange={handleField} name={'AdoorNumber'} helperText={E.address.doorNumber} error={E.address.doorNumber !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={4} sx={newBox}>
                    <Box sx={labelTitle}>Street *:</Box>
                    <TextField sx={inputShape} value={F.address.street} onChange={handleField} name={'Astreet'} helperText={E.address.street} error={E.address.street !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={4} sx={newBox}>
                    <Box sx={labelTitle}>City *:</Box>
                    <TextField sx={inputShape} value={F.address.city} onChange={handleField} name={'Acity'} helperText={E.address.city} error={E.address.city !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={2.5} sx={newBox}>
                   <Box sx={labelTitle}>Province:</Box>
                    <TextField sx={inputShape} select value={F.address.state} onChange={handleField} name={'Astate'}>
                        {provinces.map((province : i_select , index : number) =>  
                            <MenuItem key={index} value={province.value}>{province.value}</MenuItem>
                        )}
                    </TextField>
                </Grid>
                <Grid size={2.5} sx={newBox}>
                    <Box sx={labelTitle}>Country:</Box>
                    <TextField sx={inputShape} select value={F.address.country} onChange={handleField} name={'Acountry'}>
                        {country.map((country : i_select, index : number) =>  
                            <MenuItem key={index} value={country.value}>{country.value}</MenuItem>
                        )}
                    </TextField>
                </Grid>
                <Grid size={3} sx={newBox}>
                    <Box sx={labelTitle}>Postal code *:</Box>
                    <TextField sx={inputShape} value={F.address.postalCode} onChange={handleField} name={'ApostalCode'} helperText={E.address.postalCode} error={E.address.postalCode !== '' ? true : false}></TextField>
                </Grid>
                <Grid size={12} sx={newBox}>
                    <Button type="button" sx={btnSubmit} loading={props.loading} variant="contained" onClick={() => props.callback()}>Submit</Button>
                </Grid>
            </Grid >
        </Paper>
    )
}

export default UserForm;